import { useTranslation } from 'react-i18next';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Connectors, IntegrationDTO } from 'support/types';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

const CONNECTORS_REQUIRING_TOOLTIP = [Connectors.NONE];

export const ConnectorName = ({ connector }: { connector: IntegrationDTO['connector'] | null | undefined }) => {
  const { t } = useTranslation();

  const connectorToTranslate = connector ?? Connectors.NONE;

  return (
    <div className="flex items-center gap-1">
      <span>{t(`integrations:connector.${connectorToTranslate}.name`)}</span>
      {CONNECTORS_REQUIRING_TOOLTIP.includes(connectorToTranslate as Connectors) ? (
        <Tooltip>
          <TooltipTrigger>
            <InformationCircleIcon className="size-4 text-gray-400" />
          </TooltipTrigger>
          <TooltipContent>{t(`integrations:connector.${connectorToTranslate}.tooltip`)}</TooltipContent>
        </Tooltip>
      ) : null}
    </div>
  );
};
